/* src/app/modules/patternmatch/components/mrq-details/mrq-details.component.scss */
.weekend-row {
  background-color: #f2f2f2;
  color: #212121;
}
.bold-header {
  font-weight: bold;
}
.name-title {
  background-color: var(--mat-table-background-color, var(--mat-app-surface));
  padding: 0.5rem 1rem;
  margin-bottom: auto;
}
table {
  box-shadow: none;
}
.weekend-cell {
  background-color: #f2f2f2;
  color: #212121;
}
.table-container {
  margin-top: -1rem;
}
/*# sourceMappingURL=mrq-details.component.css.map */
